/**
 * Created by miguel on 15/3/17.
 */

class CashDeskListViewController extends BaseTableViewController
{   
    static newInstance() : CashDeskListViewController {
        let vc = new CashDeskListViewController("cash-desk-list-view");
        vc.initWithResource("layout/cashdesk/CashDeskListView.html");
        return vc;
    }

    private calendarButton:MUIButton = null; 
    private dateLabel:MUILabel = null;
    private totalLabel:MUILabel = null;
    
    private sdtf = MUIWebApplication.sharedInstance().delegate.serverDateTimeFormatter;

    viewDidLoad() { 
        super.viewDidLoad();

        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel")
        this.totalLabel = MUIOutlet(this, "total-lbl", "MUILabel");
        
        let tapGesture = new MUITapGestureRecognizer();
        tapGesture.initWithTarget(this, function(gesture:MUIGestureRecognizer){
            if (gesture.state == MUIGestureRecognizerState.Ended) {
                if (this.selectedItem != null) this.tableView.deselectRowAtIndexPath(this.selectedIndexPath, true);
                this.selectedItem = null;
                this.selectedIndexPath = null;
                this.showItem();        
            };
        });        
        this.totalLabel.addGestureRecognizer(tapGesture);
        

        this.calendarButton = MUIOutlet(this, 'calendar-btn','MUIButton');
        this.calendarButton.setAction(this, function(){
            let ah:AppHelper = AppHelper.sharedInstance();
            ah.presentDateSelectionViewController(this);
        });

        this.tableView = MUIOutlet(this, 'table-view', 'UITableView');
        this.tableView.dataSource = this;
        this.tableView.delegate = this; 

        this.updateDate();
        this.invalidateFetch();
    }

    private hasSummaryCell = false;
    numberOfSections(tableView:UITableView){        
        return 1;
    }
    
    numberOfRowsInSection(tableView:UITableView, section:number){
        return this.cashDeskItems.length;
    }


    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        // let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as CashDeskBalance;
        let item = this.cashDeskItems[indexPath.row];
        let cell = tableview.dequeueReusableCellWithIdentifier('CashDeskLevel2Cell') as CashDeskCell;
        cell.item2 = item;
        return cell;
    }    
        
    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        this.selectedItem = this.cashDeskItems[indexPath.row];// this.fetchedResultsController.objectAtIndexPath(indexPath) as CashDesk;
        this.showItem();
    }
        
    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;
        let sdt = ad.serverDateTimeFormatter;

        let rh = ReportHelper.sharedInstance();
        let dateTimeFrom = sdt.stringFromDate(rh.selectedDateTimeFrom);
        let dateTimeTo = sdt.stringFromDate(rh.selectedDateTimeTo);

        let predicateFormat = "sessionDate >= '" + dateTimeFrom + "' AND sessionDate <= '" + dateTimeTo + "')"; 

        let fetchRequest = MIOFetchRequest.fetchRequestWithEntityName('CashDeskBalance');        
        fetchRequest.sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey('cashdesk.name', true)];
        fetchRequest.predicate = MIOPredicate.predicateWithFormat(predicateFormat);        
        fetchRequest.relationshipKeyPathsForPrefetching = ["cashdesk"];
        
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }
        
    protected invalidateData(){        
        this.updateDate();        
        super.invalidateData();
    }

    protected reloadData(){
        this.cashDeskMap(this.fetchedResultsController.fetchedObjects);
        super.reloadData();
        this.updateTotal();
    }

    datesDidSelect(dateTimeFrom, dateTimeTo) {
        let rh = ReportHelper.sharedInstance();
        rh.selectedDateTimeFrom = dateTimeFrom;
        rh.selectedDateTimeTo = dateTimeTo;  
        this.updateDate();
        this.invalidateData();
        this.showItem();
    }

    private showItem(){                        
        if (MIOCoreIsPhone()) return;

        // let vc = new CashDeskDetailViewController("cash-desk-detail-view");
        // vc.initWithResource("layout/cashdesk/CashDeskDetailView.html");    
        // vc.cashDesk = this.selectedItem;

        // let nc = new MUINavigationController();
        // nc.initWithRootViewController(vc);

        // this.splitViewController.showDetailViewController(nc);                    

        let nc = this.splitViewController.detailViewController as MUINavigationController;
        let vc = nc.rootViewController as CashDeskDetailViewController;
        vc.cashDesk = this.selectedItem != null ? this.selectedItem["CashDesk"] : null;
    }

    private showNoItemSelectedView(){        
        if (MIOCoreIsPhone() == false){
            let vc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("CashDesk", NoItemSelectedViewControllerType.CashDesk);
            this.splitViewController.showDetailViewController(vc);
        }
    }

    private updateDate(){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;    
        
        let rh = ReportHelper.sharedInstance();
        let dayFrom = MIODateGetDateString(rh.selectedDateTimeFrom);
        let dayTo = MIODateGetDateString(rh.selectedDateTimeTo);

        if (dayFrom == dayTo) {
            this.dateLabel.text = ad.longDateFormatter.stringFromDate(rh.selectedDateTimeFrom);
        }
        else {
            this.dateLabel.text = ad.dateFormatter.stringFromDate(rh.selectedDateTimeFrom) + ' - ' + ad.dateFormatter.stringFromDate(rh.selectedDateTimeTo);
        }
    }

    private updateTotal(){    
        this.totalLabel.text = "0";

        let total = 0;
        for (let index = 0; index < this.fetchedResultsController.fetchedObjects.length; index++) {            
            let balance = this.fetchedResultsController.fetchedObjects[index] as CashDeskBalance;
            total += balance.salesAmount;
        }        

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        this.totalLabel.text = ad.currencyFormatter.stringFromNumber(total);        

        if (this.hasSummaryCell == false) return;

        let ip = MIOIndexPath.indexForRowInSection(0, 0);
        let cell = this.tableView.cellAtIndexPath(ip) as CashDeskCell;
        this.configureSummaryCell(cell, total);
    }

    private configureSummaryCell(cell:CashDeskCell, amount:number) {
        if (cell == null) return;                
        // cell.setCustomData(MIOLocalizeString("ALL_CASHDESKS", "ALL CASHDESKS"), amount);
    }

    private cashDeskItems = [];
    public cashDeskMap(balances:CashDeskBalance[]){

        let cashdesks = {};
        for (let b of balances) {
            let i = cashdesks[b.cashdesk.identifier];
            if (i == null) cashdesks[b.cashdesk.identifier] = {"Name" : b.cashdesk.name, "CashDesk": b.cashdesk, "Total" : 0};
            cashdesks[b.cashdesk.identifier]["Total"] += b.salesAmount;
        }
        
        let array = Object.keys(cashdesks).map( function(key){ return cashdesks[key]; } );
        this.cashDeskItems = _MIOSortDescriptorSortObjects(array, [MIOSortDescriptor.sortDescriptorWithKey("Name", true)]);
        this.tableView.reloadData();
    }
}